import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AiAssistantPanelService } from '@simOn/layout';
import { SimFloatingWindowComponent } from '@simOn/ui/sim-floating-window';
import { AgentChatPanelComponent } from '../agent-chat-panel/agent-chat-panel.component';

/**
 * Floating chat window, initially at the left edge of the screen below the top navbar; the user drags it
 * around by the panel header. Opened from the AI assistant launcher in the navbar
 * (`AiAssistantPanelService`). The conversation state lives in `AgentChatStore`, so closing the window
 * does not lose the chat (its position is not kept).
 */
@Component({
  selector: 'ai-agent-chat-drawer',
  imports: [AgentChatPanelComponent, SimFloatingWindowComponent],
  template: `
    @if (panel.visible()) {
      <sim-floating-window class="ai-agent-drawer__window">
        <ai-agent-chat-panel />
      </sim-floating-window>
    }
  `,
  styleUrl: './agent-chat-drawer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'ai-agent-drawer' }
})
export class AgentChatDrawerComponent {
  protected readonly panel = inject(AiAssistantPanelService);
}
